@if ((navigationInProgress$ | async) === false) {
<ngx-spinner
  size="medium"
  type="ball-clip-rotate-pulse"
  [name]="loaderName"
  [bdColor]="backdropColor"
  [color]="indicatorColor"
  [fullScreen]="fullScreen"
>
  @let text = text$ | async; @if (text) {
  <p class="le-title-large global-loader-text">{{ text }}</p>
  }
</ngx-spinner>
}
